var render = function render(){var _vm=this,_c=_vm._self._c;return (this.action)?_c('a',{class:_vm.cssClass,style:(_vm.styles),attrs:{"target":_vm.target},domProps:{"innerHTML":_vm._s(_vm.$t(_vm.text))},on:{"click":_vm.handleClick}}):_c('a',{class:_vm.cssClass,style:(_vm.styles),attrs:{"href":_vm.url,"target":_vm.target},domProps:{"innerHTML":_vm._s(_vm.$t(_vm.text))}})
}
var staticRenderFns = []

export { render, staticRenderFns }